import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
//import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Select,
  MenuItem,
  //Checkbox,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Dialog,
  //ListItemText,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import {
  Table,
  //TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";

import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
//import ArrowUpward from "@mui/icons-material/ArrowUpward";
//import ArrowDownward from "@mui/icons-material/ArrowDownward";

//import SuiBox from "components/SuiBox";
import SuiBox from "components/SuiBox";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";

import ApoderadosApi from "api/apoderadosApi";

const ApoderadoClienteModal = ({ open, onClose, cliente, onSuccess }) => {
  const [error, setError] = useState(undefined);
  const [apoderados, setApoderados] = useState([]);
  const [apoderado, setApoderado] = useState(null);
  const [apoderadoExistente, setApoderadoExistente] = useState(!!apoderado?.identificacion);
  const [listaRespAcreedores, setListaRespAcreedores] = useState([]);
  const [listaResponsables, setListaResponsables] = useState([]);
  const [tipoIdentificacion, setTipoIdentificacion] = useState("");
  const [identificacion, setIdentificacion] = useState("");
  const [nombreCompleto, setNombreCompleto] = useState("");
  const [tarjetaProfesional, setTarjetaProfesional] = useState("");
  const [celular, setCelular] = useState("");
  const [email, setEmail] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [direccion, setDireccion] = useState("");

  const fetchInitialData = async () => {
    try {
      const [apoderadosRes] = await Promise.all([ApoderadosApi.fetchApoderadosCliente(cliente.id)]);
      const apode = apoderadosRes.data || [];
      //alert("apode: " + JSON.stringify(apode));
      if (apode && !apode.message) {
        setApoderados(apode || []);
      }
    } catch (error) {
      console.error("Error al obtener los datos iniciales:", error);
    }
  };

  useEffect(() => {
    if (cliente) {
      fetchInitialData();
    }
  }, [cliente]);

  const handleIdentificacionChange = async (event) => {
    if (!event || !event.target) return; // Protección contra eventos inválidos
    const identificacion = event.target.value;
    if (!/^\d{0,15}$/.test(identificacion)) {
      setError("La Identificación debe tener sólo números");
      return;
    }
    setIdentificacion(identificacion);
    if (!identificacion || identificacion.length < 8) {
      setIdentificacion(identificacion);
      return;
    }
    try {
      const apoderadoResponse = await ApoderadosApi.fetchApoderadoByIdentificacion(identificacion);
      const apoderado = apoderadoResponse.data;
      if (apoderado && !apoderado.error) {
        setApoderado(apoderado);
        setApoderadoExistente(true);
        setIdentificacion(apoderado.identificacion);
        setTipoIdentificacion(apoderado.tipo_identificacion);
        setCiudad(apoderado.ciudad);
        setNombreCompleto(apoderado.nombre_completo);
        setCelular(apoderado.celular);
        setTarjetaProfesional(apoderado.tarjeta_profesional);
        setEmail(apoderado.email);
        setDireccion(apoderado.direccion);
        setListaResponsables(apoderado.responsable.list_clientes);
        setListaRespAcreedores(apoderado.responsable.list_acreedores);
      } else {
        setApoderadoExistente(false);
      }
      setError(null);
    } catch (error) {
      setError(obtenerMensajeError(error, "Error al verificar los datos del apoderado"));
      setApoderadoExistente(false);
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const validateEmailInput = (value) => {
    // Eliminar espacios en blanco al inicio y final
    let cleanValue = value.trim();
    // Convertir a minúsculas para consistencia
    cleanValue = cleanValue.toLowerCase();
    // Remover caracteres no permitidos en emails
    cleanValue = cleanValue.replace(/[^a-z0-9@._-]/g, "");
    return {
      value: cleanValue,
      isValid: isValidEmail(cleanValue),
      errorMessage: isValidEmail(cleanValue) ? "" : "Por favor ingrese un Email válido",
    };
  };

  const handleEmailChange = (e) => {
    const result = validateEmailInput(e.target.value);
    const email = result.value;
    setEmail(email);
    setError(result.errorMessage);
  };

  const resetState = () => {
    setError(undefined);
    setListaResponsables([]);
    setListaRespAcreedores([]);
    setTipoIdentificacion("");
    setIdentificacion("");
    setNombreCompleto("");
    setTarjetaProfesional("");
    setCelular("");
    setEmail("");
    setCiudad("");
    setDireccion("");
    setApoderado(null);
    setApoderados([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validaciones
    if (tipoIdentificacion == null) {
      setError("Debes seleccionar un Tipo de Identificación.");
      return;
    }
    if (!listaResponsables.includes(cliente.id)) {
      listaResponsables.push(cliente.id);
    }
    const datos = {
      identificacion: identificacion,
      tipo_identificacion: tipoIdentificacion,
      nombre_completo: nombreCompleto,
      tarjeta_profesional: tarjetaProfesional,
      celular: celular,
      email: email,
      direccion: direccion,
      ciudad: ciudad,
      responsable: {
        list_clientes: listaResponsables,
        list_acreedores: listaRespAcreedores,
      },
    };
    try {
      //console.log("datos: " + JSON.stringify(datos));
      let newApoderado;
      if (apoderado || apoderadoExistente) {
        newApoderado = await ApoderadosApi.updateApoderado(apoderado.id, datos);
      } else {
        newApoderado = await ApoderadosApi.createApoderado(datos);
      }
      if (newApoderado) {
        resetState();
        onSuccess();
      }
    } catch (error) {
      console.error("Error al guardar los datos del Apoderado:", error);
      setError(obtenerMensajeError(error, "Error al guardar los datos del Apoderado."));
    }
  };

  const hCClose = () => {
    resetState();
    onClose();
  };

  // const moveApoderado = (index, direction) => {
  //   setApoderados((prevApoderados) => {
  //     const newApoderados = [...prevApoderados];
  //     const newIndex = index + direction;

  //     if (newIndex >= 0 && newIndex < newApoderados.length) {
  //       [newApoderados[index], newApoderados[newIndex]] = [
  //         newApoderados[newIndex],
  //         newApoderados[index],
  //       ];
  //     }

  //     return newApoderados;
  //   });
  // };

  const removeApoderado = async (index) => {
    const apoderadoToRemove = apoderados[index];
    if (!apoderadoToRemove) return;
    try {
      const newListaResponsables = listaResponsables.filter((id) => id !== cliente.id);
      await ApoderadosApi.updateApoderado(apoderadoToRemove.id, {
        ...apoderadoToRemove,
        responsable: {
          list_clientes: newListaResponsables,
          list_acreedores: listaRespAcreedores,
        },
      });
      setApoderados((prevApoderados) => prevApoderados.filter((_, i) => i !== index));
      setListaResponsables(newListaResponsables);
    } catch (error) {
      console.error("Error al eliminar el apoderado:", error);
      setError(obtenerMensajeError(error, "No se pudo eliminar el apoderado."));
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <h2 style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
          {apoderado ? "Editar" : "Registrar"} Apoderado de
          <SuiTypography
            component="span"
            variant="h6"
            fontWeight="light"
            style={{ fontSize: "24px" }}
          >
            {cliente ? cliente.nombre_completo : "No tiene Cliente"}
          </SuiTypography>
        </h2>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={4}>
              <SuiTypography variant="h6" fontWeight="light">
                Identificación
              </SuiTypography>
              <SuiInput
                name="identificacion"
                placeholder="Identificación: dato numérico [0-9]"
                value={identificacion}
                onChange={handleIdentificacionChange}
                onBlur={handleIdentificacionChange}
                fullWidth
              />
            </Grid>
            <Grid size={4}>
              <SuiTypography variant="h6" fontWeight="light">
                Tipo de Identificación
              </SuiTypography>
              <Select
                value={tipoIdentificacion}
                onChange={(e) => setTipoIdentificacion(e.target.value)}
                displayEmpty
                fullWidth
                //disabled={apoderadoExistente}
              >
                <MenuItem value="CC">Cédula de Ciudadanía</MenuItem>
                <MenuItem value="NIT">Número de Identificación Tributaria</MenuItem>
                <MenuItem value="CE">Cédula de Extranjería</MenuItem>
                <MenuItem value="PAS">Pasaporte</MenuItem>
                <MenuItem value="OTRO">Otro</MenuItem>
              </Select>
            </Grid>
            <Grid size={4}>
              <SuiTypography variant="h6" fontWeight="light">
                Ciudad
              </SuiTypography>
              <SuiInput
                value={ciudad}
                onChange={(event) => {
                  setCiudad(event.target.value);
                  setError(undefined);
                }}
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={4}>
              <SuiTypography variant="h6" fontWeight="light">
                Nombre Completo
              </SuiTypography>
              <SuiInput
                value={nombreCompleto}
                onChange={(event) => {
                  setNombreCompleto(event.target.value);
                  setError(undefined);
                }}
                fullWidth
              />
            </Grid>
            <Grid size={4}>
              <SuiTypography variant="h6" fontWeight="light">
                No. Celular
              </SuiTypography>
              <SuiInput
                value={celular}
                onChange={(event) => {
                  setCelular(event.target.value);
                  setError(undefined);
                }}
                fullWidth
              />
            </Grid>
            <Grid size={4}>
              <SuiTypography variant="h6" fontWeight="light">
                Tarjeta Profesional
              </SuiTypography>
              <SuiInput
                value={tarjetaProfesional}
                onChange={(event) => {
                  setTarjetaProfesional(event.target.value);
                  setError(undefined);
                }}
              />
            </Grid>
          </Grid>
          <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Correo Electrónico
              </SuiTypography>
              <SuiInput
                name="email"
                value={email}
                onChange={handleEmailChange}
                type="email"
                placeholder="Email"
              />
            </Grid>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Dirección
              </SuiTypography>
              <SuiInput
                value={direccion}
                onChange={(event) => {
                  setDireccion(event.target.value);
                  setError(undefined);
                }}
                multiline
                rows={2}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <SuiButton onClick={hCClose} buttonColor="light">
            Cancelar
          </SuiButton>
          <SuiButton type="submit" variant="gradient" buttonColor="dark">
            {apoderado ? "Actualizar" : "Registrar"}
          </SuiButton>
        </DialogActions>

        {Array.isArray(apoderados) && apoderados.length > 0 && (
          <DialogContent>
            <SuiBox mb={2}>
              <SuiTypography variant="h4">Apoderados del Cliente</SuiTypography>
            </SuiBox>
            <TableContainer component={Paper}>
              <Table>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                    Identificación
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                    Nombre Completo
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>Email</TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>Celular</TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap" }} align="center">
                    Acciones
                  </TableCell>
                </TableRow>
                <TableBody>
                  {apoderados.map((apoderado, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {apoderado.tipo_identificacion} - {apoderado.identificacion}
                      </TableCell>
                      <TableCell>{apoderado.nombre_completo}</TableCell>
                      <TableCell>{apoderado.email}</TableCell>
                      <TableCell>{apoderado.celular}</TableCell>
                      <TableCell align="center">
                        {/* <IconButton onClick={() => moveApoderado(index, -1)} disabled={index === 0}>
                          <ArrowUpward />
                        </IconButton>
                        <IconButton
                          onClick={() => moveApoderado(index, 1)}
                          disabled={index === apoderados.length - 1}
                        >
                          <ArrowDownward />
                        </IconButton> */}
                        <IconButton onClick={() => removeApoderado(index)} color="error">
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        )}
      </form>
    </Dialog>
  );
};

ApoderadoClienteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  cliente: PropTypes.object,
  onSuccess: PropTypes.func.isRequired,
};

export default ApoderadoClienteModal;
